import { injectBaseConstantMethods } from "./BaseConstants";

export const STATUS = {
    APPROVED: "Approved",
    DRAFT: "Draft"
};

const displayTextKeys = {
    [STATUS.APPROVED]: "Approved",
    [STATUS.DRAFT]: "Draft"
};

const labelClass = {
    [STATUS.APPROVED]: "cs-badge-approved",
    [STATUS.DRAFT]: "cs-badge-draft"
};

export default injectBaseConstantMethods(STATUS, displayTextKeys, labelClass);
